import React, { Suspense } from 'react';
import useMetaComponentDetails from '../../hooks/useMetaComponentDetails';
import { getSelectedComponent } from './components';

const MetaComponent = ({ endPoint }) => {
  const { metaData = {} } = useMetaComponentDetails(endPoint);
  const { template = '' } = metaData;

  const { component: SelectedComponent } = getSelectedComponent(template);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SelectedComponent endPoint={endPoint} />
    </Suspense>
  );
};

export default MetaComponent;
